/**
 * Where to send someone once they are signed in. Its own module, not
 * useAuthPrompt's, so a reader of the stored URL does not depend on the auth
 * prompt hook (which most page tests mock wholesale).
 */
export const RETURN_URL_KEY = "wexare_return_url";

/**
 * Take the stored return URL if it starts with `prefix`, clearing it; leave it
 * alone otherwise, since it may belong to a different page's flow.
 */
export function takeReturnUrlUnder(prefix: string): string | null {
  const url = sessionStorage.getItem(RETURN_URL_KEY);
  if (!url?.startsWith(prefix)) return null;
  sessionStorage.removeItem(RETURN_URL_KEY);
  return url;
}
